import React, { useState } from "react";

import "react-toastify/dist/ReactToastify.css";
import PricingPlans from "../../subscription/PricingPlans";
import SubscriptionAdvantagesView from "../../subscription/SubscriptionAdvantagesView";
import { toast } from "react-toastify";
import { subscriptionService } from "../../../_services";
import SubscriptionPage from "../../subscription/SubscriptionPlans";

var Modal = require("react-bootstrap-modal");

export const SubscriptionPlans = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  requesting,
  saveAsDraft,
  draftRequesting,
}) => {
  // const [stepForm, setStepForm] = useState({ ...formData });
  const [stepForm, setStepForm] = useState({
  });
  const handleStep = (tag, value) => {
    setStepForm({ ...stepForm, [tag]: value });
    setFormData({ ...formData, ...stepForm, [tag]: value });
  };
  const handleNextStep = (e) => {
    e.preventDefault();
    const subscription = subscriptionInfo
    if(subscription && (subscription.status == 'Active')) {
      setFormData({ ...formData, ...stepForm });
      window.scrollTo({ top: 0, behavior: "smooth" });
      onNext();
    } else {
      toast.error("Please activate a subscription plan to list your property")
    }

  };

  const [subscriptionInfo, setSubscriptionInfo] = useState(null)

  const saveAsdraft = () => {
    setFormData({ ...formData, ...stepForm });
    saveAsDraft();
  };
  return (
    <form onSubmit={handleNextStep}>
      <div className={className}>
        <div className=" my-3 ">
          <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
            <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
              10
            </span>{" "}
            Subscription Plans
          </h4>
          <SubscriptionPage setSubscriptionInfo={setSubscriptionInfo}/>
        </div>
        <div>
          <button
            onClick={onPrev}
            type="button"
            className="btn btn-secondary mx-2  tw-mb-2"
          >
            Prev
          </button>
          <button type="submit" className="btn btn-secondary mx-2 tw-mb-2">
            {requesting ? "Saving ..." : "Next"}
          </button>
          <button
            type="button"
            disabled={draftRequesting}
            onClick={saveAsdraft}
            className="btn btn-secondary mx-2 tw-mb-2"
          >
            {draftRequesting ? "Adding ..." : "Save as Draft"}
          </button>
        </div>
      </div>
    </form>
  );
};
